<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.blog-add')" />
        <div class="top-right-button-container">
          <b-button
            to="/app/dashboards/blogs"
            variant="primary"
            size="lg"
            class="top-right-button"
          >
            {{ $t("pages.back") }}
          </b-button>
        </div>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-form
      @submit.prevent="onValitadeFormSubmit"
      class="av-tooltip tooltip-label-right"
    >
      <b-row>
        <b-colxx xxs="12" xl="6" lg="6">
          <b-card class="mb-4">
            <b-form-group :label="$t('forms.image')">
              <div class="mb-2 text-center">
                <img class="preview" :src="picture" />
                <p>
                  {{ uploadValue.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="uploadValue"
                    max="100"
                  ></progress>
                </p>
              </div>
              <b-form-file
                accept="image/*"
                @change="previewImage"
                required
              ></b-form-file>
            </b-form-group>
            <b-form-group :label="$t('forms.title')">
              <b-form-input
                type="text"
                v-model.trim="$v.title.$model"
                :state="!$v.title.$error"
              />
              <b-form-invalid-feedback
                >Title is required!</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group :label="$t('forms.category')">
              <v-select
                required
                v-model.trim="$v.categorySelect.$model"
                :options="selectOptions"
                :dir="direction"
              />
              <b-form-invalid-feedback
                >Please select an option!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-card>
        </b-colxx>
        <b-colxx xxs="12" xl="6" lg="6">
          <b-card class="mb-4">
            <b-form-group :label="$t('forms.description')">
              <quill-editor
                v-model.trim="$v.content.$model"
                :state="!$v.content.$error"
                ref="myQuillEditor"
                :options="editorOption"
                :dir="direction"
              >
              </quill-editor>
              <b-form-invalid-feedback
                >Please enter some contents!</b-form-invalid-feedback
              >
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              class="mt-4 text-center btn-block"
              >{{ $t("forms.submit") }}</b-button
            >
          </b-card>
        </b-colxx>
      </b-row>
    </b-form>
  </div>
</template>
<style>
img.preview {
  width: 200px;
}
.ql-container {
  height: 250px;
}
</style>
<script>
import db from "@/components/firebaseInit";
import firebase from "firebase";
import axios from "axios";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
const { required } = require("vuelidate/lib/validators");
import { getDirection } from "../../../utils";
export default {
  components: {
    "quill-editor": quillEditor,
    "v-select": vSelect
  },
  data() {
    return {
      content: "",
      editorOption: {
        // some quill options
      },
      imageData: null,
      picture: "/assets/img/picture.png",
      uploadValue: 0,
      direction: getDirection().direction,
      categorySelect: "",
      selectOptions: [
        "الشاملة",
        "محليات",
        "اقتصاد",
        "خارجية",
        "حول العالم",
        "الوفيات",
        "رياضة",
        "كلينك",
        "مقالات",
        "منوعة",
        "قضايا و محاكم",
        "شؤون عربية"
      ],
      title: "",
      select: "",
      content: "",
      image: "",
      date: moment().format("DD/MM/YYYY hh:mm a")
    };
  },
  mixins: [validationMixin],
  validations: {
    title: {
      required
    },
    content: {
      required
    },
    categorySelect: {
      required
    }
  },
  methods: {
    onValitadeFormSubmit() {
      console.log("submit!");
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.$notify("error", "Add Blog error", "", {
          duration: 3000,
          permanent: false
        });
      } else {
        // do your submit logic here
        // this.picture = null;
        const storageRef = firebase
          .storage()
          .ref(`blog/${this.imageData.name}`+this.date)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          snapshot => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          error => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then(url => {
              this.picture = url;
              this.saveBlog(url);
            });
          }
        );
      }
      console.log(
        JSON.stringify({
          title: this.title,
          image: this.image,
          categorySelect: this.categorySelect,
          content: this.content
        })
      );
    },
    saveBlog(url) {
      this.image = url;
      db.collection("blogs")
        .add({
          title: this.title,
          date: this.date,
          content: this.content,
          category: this.categorySelect,
          image: this.image
        })
        .then(docRef => {
          console.log("blog added: ", docRef.id);
          this.$notify("success", "Add Blog success", "", {
            duration: 3000,
            permanent: false
          });

          this.$router.push("/app/dashboards/blogs/blog-list");
        })
        .catch(error => {
          console.error("Error adding blog: ", error);
        });
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    previewImage(event) {
      this.uploadValue = 0;
      // this.picture = null;
      this.imageData = event.target.files[0];
    }
  },
  watch: {}
};
</script>
